import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { ISuggestResponseSchema } from '../../repositories/newbuilding-promos/entities/suggest/SuggestResponseSchema';
import { fetchGetSuggest, TGetSuggestResponse } from '../../repositories/newbuilding-promos/v1/get-suggest';
import { ResponseError } from '../../utils/errors';

interface IFetchSuggestionsParams {
  httpApi: IHttpApi;
  logger: ILogger;
  /** Запрос пользователя **/
  query: string;
  /** Поддомен **/
  subdomain: string;
}

export async function fetchSuggestions({
  httpApi,
  logger,
  query,
  subdomain,
}: IFetchSuggestionsParams): Promise<ISuggestResponseSchema> {
  try {
    const response: TGetSuggestResponse = await fetchGetSuggest({ httpApi, parameters: { query, subdomain } });

    if (response.statusCode !== 200) {
      const { errors, message } = response.response;

      throw new ResponseError({
        message: message as string,
        domain: 'services.fetchSuggestions',
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: errors as any[],
        },
      });
    }

    return response.response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
